var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVinculacionExtracurricular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 187 187",
    width: 187,
    height: 187,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vinculacion-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #d8a568 } \n\t\t.s1 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Segunda_pantalla"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m25.3 8.1h122.9c9.2 0 16.6 7.5 16.6 16.6v122.9c0 9.2-7.4 16.6-16.6 16.6h-122.9c-9.1 0-16.6-7.4-16.6-16.6v-122.9c0-9.1 7.5-16.6 16.6-16.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "s1",
    fontFamily: "sans-serif",
    fontSize: 9,
    textAnchor: "middle",
    x: 84.6,
    y: 118
  }, "Vinculaci&#243;n a grupos"), /*#__PURE__*/React.createElement("text", {
    className: "s1",
    fontFamily: "sans-serif",
    fontSize: 9,
    textAnchor: "middle",
    x: 84.6,
    y: 130
  }, "estudiantiles"), /*#__PURE__*/React.createElement("text", {
    className: "s1",
    fontFamily: "sans-serif",
    fontSize: 9,
    textAnchor: "middle",
    x: 84.6,
    y: 142
  }, "o externos")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m116.8 44.5h-14.5v-9.2h14.5zm-1.2-8h-0.8l-5.2 4.2-5.2-4.2h-0.9v6.8h12.1c0 0 0-6.8 0-6.8zm-9.3 0l3.3 2.6 3.2-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m84.9 79.1c1.9-2.1 4.7-3.3 7.5-3.3q0.5 0 1.1 0c4.7 0.5 8.5 4.3 9 9.1 0.3 2.6-0.5 5.2-2.1 7.3-0.3 0.3-0.7 0.4-1 0.4-0.4-0.1-0.7-0.3-0.9-0.7-0.5-1.2-1.6-2.1-3-2.1h-5.3c-1.5 0-2.9 1.2-3.1 2.7-0.1 0.4-0.4 0.7-0.8 0.8q-0.1 0.1-0.3 0.1-0.4 0-0.7-0.3c-1.7-1.7-2.7-3.8-3-6.2-0.2-2.9 0.7-5.6 2.6-7.8zm-0.4 7.6c0.1 1.3 0.5 2.5 1.2 3.6 0.7-1.2 1.8-2 3-2.4-0.8-0.9-1.3-2.1-1.3-3.4 0-2.8 2.2-5.1 5-5.1 2.8 0 5.1 2.3 5.1 5.1 0 1.2-0.5 2.4-1.2 3.3 1.3 0.2 2.4 0.8 3.3 1.7 0.7-1.3 0.9-2.9 0.8-4.4-0.4-3.8-3.4-6.8-7.1-7.2q-0.5 0-0.9 0c-2.2 0-4.4 1-5.9 2.6-1.6 1.7-2.3 3.9-2 6.2zm11.8-2.2c0-2.1-1.7-3.9-3.9-3.9-2.1 0-3.8 1.8-3.8 3.9 0 2.1 1.7 3.8 3.8 3.8 2.2 0 3.9-1.7 3.9-3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m50.5 53.8c0-10.1 8.2-18.3 18.3-18.3 10 0 18.2 8.2 18.2 18.3 0 4.9-1.9 9.5-5.4 13-0.2 0.2-0.5 0.3-0.8 0.3q-0.2 0-0.4-0.1c-0.4-0.2-0.6-0.5-0.6-1v-0.9c0-3.6-2.9-6.4-6.4-6.4h-9.3q-0.3 0-0.7 0 0 0 0 0c-3.2 0.4-5.7 3.1-5.7 6.4v0.9c0 0.5-0.3 0.8-0.6 1-0.4 0.2-0.9 0.1-1.2-0.2-3.5-3.5-5.4-8.1-5.4-13zm18.2-16.2c-8.9 0-16.1 7.3-16.1 16.2 0 3.5 1.1 6.8 3.2 9.6 0.7-3.6 3.6-6.3 7.3-6.8q0.1 0 0.1 0 0.1 0 0.1 0c-2.1-1.6-3.4-4.2-3.4-7 0-4.9 3.9-8.9 8.9-8.9 4.9 0 8.8 4 8.8 8.9 0 2.8-1.3 5.3-3.4 7 3.8 0.4 6.8 3.2 7.6 6.8 2-2.8 3.1-6.1 3.1-9.6 0-8.9-7.2-16.2-16.1-16.2zm0.9 19c3.5-0.5 6.1-3.5 6.1-7 0-3.9-3.2-7.1-7-7.1-3.9 0-7.1 3.2-7.1 7.1 0 3.5 2.7 6.5 6.1 7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m95.8 39.5c0-7.6 6.2-13.7 13.8-13.7 7.5 0 13.7 6.1 13.7 13.7 0 7.5-6.2 13.7-13.8 13.7-7.5 0-13.7-6.2-13.7-13.7zm2.2 0c0 6.3 5.2 11.5 11.6 11.5 6.3 0 11.5-5.2 11.5-11.5 0-6.4-5.2-11.6-11.6-11.6-6.3 0-11.5 5.2-11.5 11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m68.8 32.4c8 0 15.3 4.5 19 11.6l5.3-1.9q-0.2-1.3-0.2-2.6c0-9.2 7.5-16.7 16.7-16.7 9.1 0 16.6 7.5 16.6 16.7 0 9.2-7.5 16.6-16.6 16.6-6.4 0-12.1-3.5-14.9-9.2l-5.1 1.8c0.4 1.7 0.6 3.4 0.6 5.1 0 6.4-2.9 12.5-7.9 16.5l3.8 4.2c2.3-1.3 5-1.9 7.7-1.6 6.1 0.6 11.1 5.5 11.7 11.7 0.3 3.7-0.8 7.3-3.4 10.1-2.4 2.7-6 4.3-9.7 4.3q-0.6 0-1.3-0.1c-6.2-0.6-11.1-5.5-11.7-11.7-0.3-3.4 0.6-6.8 2.8-9.4l-4.2-4.7c-2.9 1.4-6.1 2.1-9.2 2.1-11.9 0-21.5-9.6-21.5-21.4 0-11.8 9.6-21.4 21.5-21.4zm0 2.1c-10.7 0-19.3 8.7-19.3 19.3 0 10.7 8.6 19.3 19.3 19.3 3.1 0 6.1-0.7 8.9-2.2q0.3-0.1 0.5-0.1c0.3 0 0.6 0.1 0.8 0.3l5.4 6c0.3 0.4 0.3 1 0 1.4 0 0-0.1 0.1-0.1 0.1-2.1 2.3-3.1 5.3-2.8 8.4 0.5 5.2 4.7 9.3 9.8 9.8q0.6 0.1 1.2 0.1c3 0 6-1.3 8.1-3.6 2.1-2.3 3.1-5.4 2.8-8.5-0.5-5.2-4.7-9.3-9.8-9.8-2.5-0.3-5 0.4-7.1 1.7-0.5 0.3-1.1 0.2-1.4-0.1l-5.1-5.7q-0.3-0.3-0.3-0.8c0.1-0.3 0.2-0.6 0.5-0.8 4.9-3.6 7.9-9.4 7.9-15.5q0-2.7-0.8-5.4c-0.2-0.6 0.1-1.2 0.7-1.3l6.9-2.5c0.5-0.2 1.1 0.1 1.3 0.6 2.3 5.4 7.5 8.8 13.4 8.8 8 0 14.5-6.5 14.5-14.5 0-8.1-6.5-14.6-14.5-14.6-8.1 0-14.6 6.5-14.6 14.6q0 1.5 0.4 3.1c0.1 0.5-0.2 1-0.7 1.2l-7.1 2.5c-0.5 0.2-1.1-0.1-1.3-0.6-3.2-6.8-10.1-11.2-17.5-11.2z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinculacionExtracurricular);
export default __webpack_public_path__ + "static/media/vinculacion_extracurricular.68a0db3007b923fd8ca56e41d16b6e07.svg";
export { ForwardRef as ReactComponent };